export { default } from './SeoSubcategoryList';